/** A countdown is informational: reaching zero never admits a participant. */
export function preEventCountdown(startsAt: string, nowMs = Date.now()): string | null {
  const start = Date.parse(startsAt);
  if (!Number.isFinite(start) || !Number.isFinite(nowMs)) return null;
  const remaining = Math.max(0, Math.ceil((start - nowMs) / 1000));
  const days = Math.floor(remaining / 86400);
  const hours = Math.floor((remaining % 86400) / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${days ? `${days}z ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}
